module.exports = __webpack_public_path__ + "static/Calluna-It-webfont-faca23ff75b714a8c19ff7a87fba09ce.woff";